import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlined';
import { Box, Button, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import {
  INCOME_BREAKDOWNS_TABLE_ARIA_LABEL,
  INCOME_BREAKDOWNS_TABLE_COLUMN_WIDTHS,
  INCOME_BREAKDOWNS_TABLE_HEADERS,
  INCOME_BREAKDOWNS_TABLE_MIN_WIDTH,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/incomeBreakdowns/constants.ts';
import { IncomeBreakdownRow } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/incomeBreakdowns/IncomeBreakdownRow.tsx';
import { FinancialConditionTable } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTable.tsx';
import type { IIncomeBreakdownsSectionProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/incomeBreakdowns/types.ts';
import {
  BorrowerType,
  type TFinancialConditionFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { createIncomeBreakdown } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const IncomeBreakdownsSection: React.FC<IIncomeBreakdownsSectionProps> = ({ disabled }) => {
  const { control, watch } = useFormContext<TFinancialConditionFormValues>();
  const borrowerType = watch('borrowerType')?.value;
  const isSoleTrader = borrowerType === BorrowerType.SoleTrader;
  const { fields, append, remove } = useFieldArray({ control, name: 'incomeBreakdowns' });

  if (!isSoleTrader) {
    return null;
  }

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        8. Розшифровка загальної суми доходів
      </Typography>
      <FinancialConditionTable
        ariaLabel={INCOME_BREAKDOWNS_TABLE_ARIA_LABEL}
        headers={[...INCOME_BREAKDOWNS_TABLE_HEADERS]}
        showActions={fields.length > 1}
        columnWidths={[...INCOME_BREAKDOWNS_TABLE_COLUMN_WIDTHS]}
        minWidth={INCOME_BREAKDOWNS_TABLE_MIN_WIDTH}
      >
        {fields.map((field, index) => (
          <IncomeBreakdownRow
            key={field.id}
            index={index}
            canRemove={fields.length > 1}
            disabled={disabled}
            onRemove={() => remove(index)}
          />
        ))}
      </FinancialConditionTable>
      <Button
        variant="outlined"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => append(createIncomeBreakdown())}
        disabled={disabled}
        sx={documentGenerationFormStyles.addButton}
      >
        Додати дохід
      </Button>
    </Box>
  );
};
